
  <h3 class="font-medium text-lg mb-4 text-amber-700">{{ 'Herramientas y servicios externos' | translate }}</h3>
  <div>
    <p class="text-sm text-gray-600 mb-6">
      {{ 'Integraciones con herramientas externas mediante el protocolo MCP (Model Context Protocol).' | translate }}
    </p>
  </div>
  <div class="grid grid-cols-4 gap-4 mb-6">
      <app-tarjeta-resumen-datos [titulo]="'MCP Servers'"
                                 [subtitulo]="numeroMcpServers > 1 ? numeroMcpServers + ' servidores' : numeroMcpServers + ' servidor'"
                                 [icono]="'server-stack.svg'"
                                 [color]="'bg-amber-100'"
                                 [cargando]="cargando">
      </app-tarjeta-resumen-datos>
    </div>
  <div class="bg-amber-50 p-4 rounded-xl border border-amber-100 mt-5">
    <h4 class="text-xs font-medium mb-2 text-amber-700 flex items-center">
      <img src="../../../../../assets/img/iconos/shield-exclamation-amber.svg" alt="" height="20" width="20" class="mr-1">
      {{ 'Información sobre integraciones' | translate }}
    </h4>
    <p class="text-xs text-amber-600">
      {{ 'Los servidores MCP permiten conectar herramientas externas al sistema, ampliando las capacidades del modelo con acceso a servicios, APIs y funcionalidades adicionales.' | translate }}
    </p>
  </div>
